import React, { Component, useEffect } from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const STYLE_CLASSNAME = 'disableYouSeeNav';

const CheckoutWrapper = (props) => {
  const addStyles = () => {
    const disableNav = `
            <style class="${STYLE_CLASSNAME}">
                #navheaderButtonMain,
                #navheaderButtonSelfcare {
                    display: none;
                }

                .navheader__logo-link {
                    pointer-events: none;
                }
            </style>
        `;

    document.querySelector('body').insertAdjacentHTML('afterbegin', disableNav);
  };

  const removeStyles = () => {
    let styleElement = document.querySelector(`.${STYLE_CLASSNAME}`);
    styleElement && styleElement.parentNode.removeChild(styleElement);
    styleElement = null; // Remove reference
  };

  useEffect(() => {
    addStyles();

    // returned function will be called on component unmount
    return () => {
      removeStyles();
    };
  }, []);

  return (
    <div className="component-checkout container container--scale-content">
      <h1 className="component-checkout__title"></h1>
      {props.children}
    </div>
  );
};

export default CheckoutWrapper;
